import React from 'react';

export default class Page8 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <table
                                                className="ilead_v_sport tablesrink uiheading ilead_v_sport_center"
                                                border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left" valign="center"
                                                        width="20%">Preference
                                                    </th>
                                                    <th className="green_curve1" align="left"
                                                        valign="center" width="40%">Tips
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg"> Literal</span></p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You consider the exact meaning of information
                                                            given to you and can use this
                                                            focus to consider the practical impact of
                                                            situations or information. You may,
                                                            however, find it hard to think beyond what is
                                                            immediately familiar to you and
                                                            find it stressful when people ask you to do
                                                            things differently. Try to think beyond
                                                            immediate facts, to possibilities and
                                                            potential.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">Logical</span></p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You rely on facts and data to solve problems. You
                                                            can use this approach to
                                                            ensure you take all relevant information into
                                                            consideration. You can be too
                                                            ‘matter of fact’ sometimes, unwilling to
                                                            recognise emotional or other factors.
                                                            Try to be more aware of your instinct and other
                                                            senses.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">Intuitive</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You go with your first impressions and pay a lot
                                                            of attention to what your
                                                            senses are telling you, even when you may not be
                                                            able to support this with
                                                            logic or facts. You can also use your intuition
                                                            to pick up more than available
                                                            facts alone provide. Try to ensure your feelings
                                                            don’t overrule facts or subvert
                                                            your judgement.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span
                                                            className="subtiltereg"> Experiential</span></p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You try to imagine or visualise yourself in a
                                                            situation to find solutions.
                                                            You can use this technique to ‘live’ different
                                                            aspects of a situation and then
                                                            consider it as a whole. You may need to take a
                                                            step back and time to reflect
                                                            on the problem, to weigh up and clarify your
                                                            thoughts.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span
                                                            className="subtiltereg"> Observational</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You could use this approach to coax people away
                                                            from detail to find different
                                                            perspectives or long-term solutions. Sometimes,
                                                            you might benefit from
                                                            immersing yourself more in detail to experience
                                                            the immediate reality or impact
                                                            of a situation on others.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg"> Pictorial</span>
                                                        </p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You use imagery or visualisation to solve
                                                            problems. This enables you to
                                                            assimilate facts and other information more
                                                            easily. You could turn ideas,
                                                            concepts, plans and diagrams into graphic visual
                                                            aids so others can better
                                                            understand otherwise complex ideas.
                                                            Alternatively, try talking things through
                                                            with someone else or listening to yourself, just
                                                            to hear how your ideas sound
                                                            when described, without visual
                                                            demonstration.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg"> Aural</span></p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You would talk about problems or situations with
                                                            others or on your own
                                                            (self-talk). Hearing the information helps you
                                                            recognise its important aspects
                                                            and prompts solutions. Try, also, to use your
                                                            other senses, especially vision,
                                                            to observe more and note how much information
                                                            you really ‘see’ when you
                                                            pay attention!</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg"> Challenging</span>
                                                        </p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You challenge and question to establish missing
                                                            or inconsistent information.
                                                            You can, therefore, help others to question
                                                            information provided. Sometimes,
                                                            however, people may think you’re being obstinate
                                                            or confrontational,
                                                            so practise using your instinct to judge when to
                                                            accept what you’re told,
                                                            or other people’s views.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg"> Accepting</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You accept information at face value. You can
                                                            help others focus on available
                                                            information rather than disputing or elaborating
                                                            on it. You should, however,
                                                            recognise that you are entitled to challenge
                                                            something it you feel it
                                                            appropriate, and do so.</p>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page9')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}